import React, { forwardRef, useImperativeHandle } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import IconExport from "@mui/icons-material/FileDownload";
import logUrl from '../../assets/insurality.png';

const ExportButton = forwardRef((props, ref) => {
  const handleExportClick = async () => {
    const element = document.getElementById("export");
    if (!element) {
      console.error("Element with id 'export' not found");
      return;
    }

    try {
      // Clone the element to avoid layout issues
      const clone = element.cloneNode(true);
      clone.style.backgroundColor = "#ffffff";
      clone.style.width = `${element.offsetWidth}px`;
      clone.style.overflow = "visible";
      clone.style.position = "absolute";
      clone.style.left = "-9999px";
      clone.style.top = "0";
      document.body.appendChild(clone);

      // Ensure all children are also visible
      clone.querySelectorAll('[style*="overflow"]').forEach(el => {
        el.style.overflow = "visible";
      });

      // Wait to ensure layout settles
      await new Promise(resolve => setTimeout(resolve, 300));

      const canvas = await html2canvas(clone, {
        scale: window.devicePixelRatio,
        useCORS: true,
        width: clone.offsetWidth,
        height: clone.offsetHeight,
      });

      document.body.removeChild(clone); // Clean up

      const image = canvas.toDataURL("image/png");

      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(image);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const margin = 10;
      const contentWidth = pdfWidth - margin * 2;
      const contentHeight = (imgProps.height * contentWidth) / imgProps.width;

      // Logo
      const logoWidth = 25;
      const logoHeight = 5;
      const logoX = 5;
      const logoY = 10;
      const textY = logoY + logoHeight / 2 + 2;
      const textX = logoX + logoWidth + 30;

      pdf.addImage(logUrl, "PNG", logoX, logoY, logoWidth, logoHeight);

      // Heading
      const addLetterSpacing = (text, spacing = 1) =>
        text.split("").join(" ".repeat(spacing));
      const heading = addLetterSpacing("LIFETIME REPORT", 1.1);

      pdf.setTextColor(36, 82, 123);
      pdf.setFontSize(18);
      pdf.setFont("Arial", "normal");
      pdf.text(heading, textX, textY);

      // Main content
      const imageYPosition = logoY + logoHeight + 20;
      pdf.addImage(image, "PNG", margin, imageYPosition, contentWidth, contentHeight);

      pdf.save("Insurality.pdf");
    } catch (error) {
      console.error("An error occurred while exporting the PDF:", error);
    }
  };

  useImperativeHandle(ref, () => ({
    export: handleExportClick,
  }));

  return (
    <button onClick={handleExportClick} style={props.style}>
      <IconExport />
    </button>
  );
});

export default ExportButton;
